import {
  buildOptionalParams,
  buildPath,
  buildTemplatePath,
  CrudMode,
  Dialog,
  handleClose,
  PageRoute,
  useParams,
  useUnsavedChanges,
  useValidationErrors,
} from "@compass/core";
import { ContributorMatchService, ContributorMatchServiceViewResource, Permission } from "generated/openApi";
import "moment-timezone";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "services/apiService";
import { ContributorMatchServicePageBody } from "./ContributorMatchServicePageBody";
import { ContributorMatchServicePageHeader } from "./ContributorMatchServicePageHeader";

const routeName = "contributorMatchService";

class Params {
  id: number = 0;
  crudMode: CrudMode = "view";
}

export const contributorMatchServicePageRoute: PageRoute<Params> = {
  handle: "Service",
  templatePath: buildTemplatePath(routeName, Params),
  getPath: (params) => buildPath(routeName, params),
};

export const ContributorMatchServicePage = () => {
  const ROOT_PERMISSION: Permission = Permission.SystemUtility;
  const navigate = useNavigate();
  const { params } = useParams(routeName, Params);
  const [contributorMatchService, setContributorMatchService] = useState<ContributorMatchService>(
    {} as ContributorMatchService
  );
  const [initContributorMatchService, setInitContributorMatchService] =
    useState<ContributorMatchService>(contributorMatchService);
  const [viewResource, setViewResource] = useState<ContributorMatchServiceViewResource>({});
  const { unsavedChanges, resetUnsavedChanges } = useUnsavedChanges({ trackedItems: [contributorMatchService] });
  const { validationErrors, setValidationErrors } = useValidationErrors();

  useEffect(() => {
    fetch(params.id);

    ApiService.contributorMatchServices.getViewResource().then((response) => {
      setViewResource(response);
    });
  }, []);

  const reroute = (id: number, crudMode: CrudMode) =>
    navigate(`../${contributorMatchServicePageRoute.getPath({ id: id, crudMode: crudMode })}`);

  const fetch = (id: number) => {
    ApiService.contributorMatchServices.get(id).then((response) => {
      setContributorMatchService(response);
      setInitContributorMatchService(response);
      resetUnsavedChanges([response]);
    });
  };

  return (
    <Dialog
      isForm
      open={true}
      onClose={() => handleClose(navigate, unsavedChanges)}
      maxWidth="sm"
      header={
        <ContributorMatchServicePageHeader
          rootPermission={ROOT_PERMISSION}
          handle={contributorMatchServicePageRoute.handle}
          crudMode={params.crudMode}
          reroute={reroute}
          fetch={fetch}
          contributorMatchService={contributorMatchService}
          setContributorMatchService={setContributorMatchService}
          initContributorMatchService={initContributorMatchService}
          setValidationErrors={setValidationErrors}
          unsavedChanges={unsavedChanges}
          resetUnsavedChanges={resetUnsavedChanges}
        />
      }
      content={
        <ContributorMatchServicePageBody
          contributorMatchService={contributorMatchService}
          setContributorMatchService={setContributorMatchService}
          viewResource={viewResource}
          crudMode={params.crudMode}
          validationErrors={validationErrors}
        />
      }
    />
  );
};
